"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StepBar = require("./StepBar.helper");
var _DefaultStepBar = _interopRequireDefault(require("./components/DefaultStepBar"));
var _StepProgressBar = _interopRequireDefault(require("./components/StepProgressBar"));
var _excluded = ["step", "defaultStep", "steps", "onChange", "disableClickEvent", "variant"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StepBar = function StepBar(_ref) {
  var step = _ref.step,
    defaultStep = _ref.defaultStep,
    steps = _ref.steps,
    onChange = _ref.onChange,
    disableClickEvent = _ref.disableClickEvent,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(stepIndex !== null && stepIndex !== void 0 ? stepIndex : 0),
    _useState2 = _slicedToArray(_useState, 2),
    stepIndex = _useState2[0],
    setStepIndex = _useState2[1];
  (0, _react.useEffect)(function () {
    return defaultStep ? setStepIndex((0, _StepBar.getIndex)(defaultStep)) : setStepIndex((0, _StepBar.getIndex)(step));
  }, [step, defaultStep]);
  var handleButtonClick = function handleButtonClick(index) {
    if (!step) {
      setStepIndex(index);
    }
    onChange({
      step: index + 1
    });
  };
  var StepVariantComponent = {
    stepProgressBar: _StepProgressBar["default"],
    "default": _DefaultStepBar["default"]
  }[variant];
  return /*#__PURE__*/_react["default"].createElement(StepVariantComponent, _extends({
    step: stepIndex,
    steps: steps,
    disableClickEvent: disableClickEvent,
    onChange: onChange,
    onItemClick: handleButtonClick
  }, props));
};
StepBar.propTypes = {
  /**
   * The number of the current step for externally controlled
   * stepbars
   */
  step: _propTypes["default"].number,
  /**
   * The initial step to be displayed in internally cntrolled stepbars.
   */
  defaultStep: _propTypes["default"].number,
  /**
   * An array containing the titles of the steps in the display order.
   */
  steps: _propTypes["default"].arrayOf(_propTypes["default"].string),
  /**
   * A string that defines which variant of the stepbar will be displayed
   */
  variant: _propTypes["default"].oneOf(['default', 'stepProgressBar']),
  /**
   * Emits the value for the selected step when the user clicks
   * in any step button
   */
  onChange: _propTypes["default"].func,
  /**
   * Disable click event on step. If true, you need to control step state
   */
  disableClickEvent: _propTypes["default"].bool
};
StepBar.defaultProps = {
  step: 0,
  defaultStep: 0,
  steps: [],
  variant: 'default',
  onChange: function onChange() {
    return undefined;
  },
  disableClickEvent: false
};
var _default = exports["default"] = StepBar;